// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HzTM","col":"styles_col__3s-V4"};